module.exports = __webpack_public_path__ + "img/4-2.9a216107.svg";